/**
 * We are checking are we local or not, because for local setting we need to use an external mediaserver!
 * For all the ports for the external mediaserver, we append a 2.
 */
const currentSite = new URL(process.env.REACT_APP_API_URL);
// const currentSite = new URL(process.env.REACT_APP_API_URL);
const isLocal = currentSite.hostname === 'localhost';

/**
 * IP address for stream publishing, should be absolute for zoom,
 *  special if we are local, and the current otherwise
 */
const publishServerHostname = isLocal ? '51.250.32.177' : currentSite.hostname;

/**
 * IP address for stream reading inside the website,
 *  again special if we are local, and the localhost otherwise
 */
const readingServerHostname = isLocal ? '51.250.32.177' : currentSite.hostname;

/**
 * Port for stream publishing, see the upmost commentary
 */
const publishServerPort = isLocal ? 21935 : 1935;

/**
 * HLS REading port, , see the upmost commentary
 */
const readingHLSPort = isLocal ? 28888 : 8888;

/**
 * Protocol for stream publishing
 */
const publishProtocol = 'rtmp';

/**
 * protocol for reading stream
 */
const readingProtocol = isLocal ? 'http' : 'https';

/**
 * Raw stream videos path
 */
const rawPublishPath = 'raw';

/**
 * Authorization scheme for publishing streams
 */
export const mediaServerPublishingAuthorizationQuery = `?user=${process.env.REACT_APP_MEDIAMTX_SERVER_USER}\
&pass=${process.env.REACT_APP_MEDIAMTX_SERVER_PASSWORD}`;

/**
 * Authorization scheme for reading streams
 */
export const mediaServerReadingAuthorizationQuery = `?user=${process.env.REACT_APP_MEDIAMTX_CLIENT_USER}\
&pass=${process.env.REACT_APP_MEDIAMTX_CLIENT_PASSWORD}`;

/**
 * media server base url
 */
const mediaServerPublishURL = `${publishProtocol}://${publishServerHostname}:${publishServerPort}`;

/**
 * media server base url
 */
const mediaServerReadURL = `${readingProtocol}://${readingServerHostname}:${readingHLSPort}`;

/**
 * Media base path for publishing
 */
export const publishingBaseURL = `${mediaServerPublishURL}/${rawPublishPath}`;

/**
 * Basic path for playback route
 */
export const playbackRoutePath = 'stream';

/**
 * Basic path for reading streams
 */
export const readingBaseURL = `${mediaServerReadURL}/${rawPublishPath}`;
